import { SubscribableCache } from "@buildwithflux/shared";
/**
 * A Firestore-backed implementation of a SubscribableCache. Stores entries in
 * a single Firestore collection, using URI-encoding to encode keys to
 * Firestore document IDs.
 *
 * Use the high-level cache API (read, write, delete, subscribe) to interact
 * with this cache.
 *
 * @see SubscribableCache
 */
export class FirestoreCache extends SubscribableCache {
    collection;
    /**
     * Creates a new cache instance.
     * @param collection The Firestore collection to store entries in.
     */
    constructor(collection) {
        super();
        this.collection = collection;
    }
    encodeKey(key) {
        return encodeURIComponent(key);
    }
    decodeKey(key) {
        return decodeURIComponent(key);
    }
    async readEntry(key) {
        if (this.isKeyEmpty(key))
            return null;
        const doc = await this.collection.doc(this.encodeKey(key)).get();
        return doc.data() ?? null;
    }
    async writeEntry(key, entry) {
        if (this.isKeyEmpty(key))
            throw new Error("Blank cache keys are not supported");
        await this.collection.doc(this.encodeKey(key)).set(entry);
    }
    async deleteEntry(key) {
        if (this.isKeyEmpty(key))
            return;
        await this.collection.doc(this.encodeKey(key)).delete();
    }
    watchEntry(key, onChange) {
        if (this.isKeyEmpty(key))
            return () => { };
        return this.collection.doc(this.encodeKey(key)).onSnapshot((snapshot) => {
            onChange(snapshot.data() ?? null);
        });
    }
    isKeyEmpty(key) {
        return !key;
    }
}
//# sourceMappingURL=cache.js.map